import { ifBasePath } from '../config/baseConfig';
import Redux from '../redux/ReduxConnector';

/**
 * CSVダウンロード種別
 */
export enum CsvDownloadType {
  /** 新規登録データ */
  NEW_PROPERTY = 'NEW_PROPERTY',
  /** 取消・変更・解約・退去データ */
  MODIFY_PROPERTY = 'MODIFY_PROPERTY',
  /** 全件 */
  ALL_PROPERTY = 'ALL_PROPERTY',
  /** ビューン */
  VIEWN = 'VIEWN',
  /** 修理保険 (新規) */
  NEW_INSURANCE = 'NEW_INSURANCE',
  /** 修理保険 (取消・変更・解約・退去) */
  MODIFY_INSURANCE = 'MODIFY_INSURANCE'
}

export async function registerDownloadLog(csvType: CsvDownloadType): Promise<boolean> {
  const user = Redux.getStore().user;
  const logUrl = `${ifBasePath}application/csv/download-logs`;
  const method = 'POST';
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'x-api-key': user.accessToken
  };
  const body = JSON.stringify({
    userId: user.userId,
    csvDownloadType: CsvDownloadType[csvType]
  });

  try {
    const res = await fetch(logUrl, {
      method,
      headers,
      body,
      mode: 'cors'
    });

    return res.ok;
  } catch (error) {
    console.error('Log write failed:', error);
    return false;
  }
}
